/* eslint-disable no-redeclare */
export const DerVariant = {
    Default: 'default',
    DefaultInverted: 'default-inverted',
    Reduced: 'reduced',
    ReducedInverted: 'reduced-inverted',
} as const;
export type DerVariant = (typeof DerVariant)[keyof typeof DerVariant];

export const Direction = {
    Left: 'left',
    Right: 'right',
} as const;
export type Direction = (typeof Direction)[keyof typeof Direction];

export interface ClassBuilder {
    class: string[];
    case: boolean;
    excludeOn?: string[];
    modifier?: ClassBuilder[];
}

export interface SelectOption {
    label: string;
    value: string;
    group?: string;
}

export const CalendarMode = {
    Single: 'single',
    Range: 'range',
} as const;
export type CalendarMode = (typeof CalendarMode)[keyof typeof CalendarMode];

export interface SingleDateChange {
    mode: typeof CalendarMode.Single;
    date: string;
}

export interface RangeDateChange {
    mode: typeof CalendarMode.Range;
    start: string;
    end: string;
}

export const Sheets = {
    Single: 1,
    Double: 2,
} as const;
export type Sheets = (typeof Sheets)[keyof typeof Sheets];
